export const FIND_EDOK_FORM_FAILURE = 'FIND_EDOK_FORM_FAILURE';

export const findEdokFormFailure = error => ({
    type: FIND_EDOK_FORM_FAILURE,
    payload: error,
    error: true,
});
